export enum EnumIndstatusStatus {
    ATIVADO = 0,
    DESATIVADO = 1,
}